import React, { Component } from 'react';
import _ from 'lodash';

import SortableTable from 'components/SortableTable';
import {
  getPlatformOptions,
  getSessionOptions,
  getFlightOptions
} from 'util/options';
import {
  getBenchLabel
} from 'util/meetHelper';

import DefaultCell from './cells/DefaultCell';
import ReadOnlyCell from './cells/ReadOnlyCell';
import PlatformCell from './cells/PlatformCell';
import RackHeightCell from './cells/RackHeightCell';
import AttemptCell from './cells/AttemptCell';

class WeighInEntryTable extends Component {

  getAllColumns = () => {
    const columns = [
      {
        key: 'name',
        label: 'Name',
        width: 190,
        type: 'text',
        sortable: true,
        sortFunction: (row) => _.toLower(row.name),
        sortDirection: 'asc',
        sortOrder: 2,
        renderer: ReadOnlyCell
      },
      {
        key: 'lot',
        label: 'Lot',
        width: 80,
        type: 'number',
        sortable: true,
        sortDirection: 'asc',
        sortOrder: 1,
        renderer: ReadOnlyCell
      },
      {
        key: 'platformId',
        label: 'Platform',
        width: 90,
        type: 'select',
        options: getPlatformOptions,
        sortable: true,
        sortFunction: (row) => _.get(this.props.meet, ['platforms', row.platformId, 'name']),
        sortDirection: 'asc',
        sortOrder: 5,
        renderer: PlatformCell
      },
      {
        key: 'session',
        label: 'Session',
        width: 90,
        type: 'select',
        options: getSessionOptions,
        sortable: true,
        sortDirection: 'asc',
        sortOrder: 4,
        renderer: ReadOnlyCell
      },
      {
        key: 'flight',
        label: 'Flight',
        width: 90,
        type: 'select',
        options: getFlightOptions,
        sortable: true,
        sortDirection: 'asc',
        sortOrder: 3,
        renderer: ReadOnlyCell
      },
      {
        key: 'bodyWeight',
        label: 'Body Weight',
        width: 120,
        type: 'number',
        sortable: true,
        sortFunction: (row) => _.toNumber(row.bodyWeight),
        sortDirection: 'asc',
        sortOrder: 9,
        renderer: DefaultCell
      },
      {
        key: 'squatRackHeight',
        liftName: 'squat',
        label: 'Squat Rack Height',
        width: 160,
        type: 'text',
        sortable: true,
        sortDirection: 'asc',
        sortOrder: 16,
        renderer: RackHeightCell
      },
      {
        key: 'benchRackHeight',
        liftName: 'bench',
        label: `${getBenchLabel(this.props.meet)} Rack Height`,
        width: 170,
        type: 'text',
        sortable: true,
        sortDirection: 'asc',
        sortOrder: 17,
        renderer: RackHeightCell
      },
      {
        key: 'lifts.squat.1',
        label: 'Squat 1',
        width: 90,
        liftName: 'squat',
        attemptNumber: 1,
        sortable: true,
        sortFunction: (row) => _.toNumber(_.get(row, ['lifts', 'squat', 1, 'weight'])),
        sortDirection: 'asc',
        sortOrder: 10,
        renderer: AttemptCell
      },
      {
        key: 'lifts.bench.1',
        label: `${getBenchLabel(this.props.meet)} 1`,
        width: 90,
        liftName: 'bench',
        attemptNumber: 1,
        sortable: true,
        sortFunction: (row) => _.toNumber(_.get(row, ['lifts', 'bench', 1, 'weight'])),
        sortDirection: 'asc',
        sortOrder: 11,
        renderer: AttemptCell
      },
      {
        key: 'lifts.dead.1',
        label: 'Dead 1',
        width: 90,
        liftName: 'dead',
        attemptNumber: 1,
        sortable: true,
        sortFunction: (row) => _.toNumber(_.get(row, ['lifts', 'dead', 1, 'weight'])),
        sortDirection: 'asc',
        sortOrder: 12,
        renderer: AttemptCell
      }
    ];

    return columns;
  }

  getCellLines = (index, lifters) => {
    return 1;
  }

  render() {
    return (
      <SortableTable
        data={this.props.lifters}
        columns={this.getAllColumns()}
        getCellLines={this.getCellLines}
        meet={this.props.meet}
        numberOfFixedLeftColumns={1}
        media={this.props.media}
      />
    );
  }
}

export default WeighInEntryTable;
